import { takeLatest } from "redux-saga/effects";
import { Types as AllTypes } from "../../actions";
import { exportUsers, exportAttemptsAnalytics } from "../../actions/export-users";
import { printCurrentPage } from "../../actions/misc";

const Types = (AllTypes as any)._APP;
const UserTypes = (AllTypes as any)._APP._USERS;

export function* watchPrintCurrentPage() {
  yield takeLatest(Types.PRINT_CURRENT_PAGE, printCurrentPage);
}

export function* watchExportUsers() {
  yield takeLatest(UserTypes.EXPORT_USERS, exportUsers);
}

export function* watchExporAttemptsAnalytics() {
  yield takeLatest(UserTypes.EXPORT_ATTEMPTS_ANALYTICS, exportAttemptsAnalytics);
}
